// Copyright © 2023 CATTLEytics Inc.

export enum SignedUrlType {
  Medium = 'medium',
  Original = 'original',
  Thumbnail = 'thumb',
}
